import dayjs from 'dayjs'

const onceTime = [
  {
    title: '1ex',
    name: '1ex',
    value: ['08:00'],
  },
]

const period = [
  {
    title: 'Mor',
    name: 'morning',
    value: ['08:00'],
    checked: false,
  },
  {
    title: 'No',
    name: 'noon',
    value: ['12:00'],
    checked: false,
  },
  {
    title: 'Eve',
    name: 'evening',
    value: ['17:00'],
    checked: false,
  },
]

const x = [
  {
    title: '1X',
    name: '1',
  },
  {
    title: '2X',
    name: '2',
  },
  {
    title: '3X',
    name: '3',
  },
  {
    title: '4X',
    name: '4',
  },
]

const hr = [
  {
    title: '6h',
    name: '6',
  },
  {
    title: '12h',
    name: '12',
  },
  {
    title: '18h',
    name: '18',
  },
  {
    title: '24h',
    name: '24',
  },
]

const mn = [
  {
    title: '5',
    name: '5',
    value: ['08:00'],
  },
  {
    title: '10',
    name: '10',
    value: ['12:00'],
  },
  {
    title: '15',
    name: '15',
    value: ['17:00'],
  },
  {
    title: '20',
    name: '20',
    value: ['17:00'],
  },
]

const intervalTime = {
  X: x,
  H: hr,
  mn: mn,
  Meal: period,
}

const timeType = [
  {
    title: 'Meal',
    type: 'Meal',
  },
  {
    title: 'X',
    type: 'X',
  },
  {
    title: 'h',
    type: 'H',
  },
  {
    title: 'mn',
    type: 'mn',
  },
]

const repeatTimes = {
  X: [
    ['08:00'],
    ['08:00', '20:00'],
    ['08:00', '13:00', '20:00'],
    ['08:00', '13:00', '17:00', '21:00'],
    ['08:00', '14:00', '19:00', '00:00', '05:00'],
    ['08:00', '13:00', '17:00', '21:00', '01:00', '05:00'],
    ['08:00', '13:00', '17:00', '21:00', '01:00', '05:00', '07:00'],
  ],
  H: [
    ['02:00', '08:00', '14:00', '20:00'],
    ['00:00', '12:00'],
    ['00:00', '18:00'],
    ['00:00'],
  ],
  mn: [['00:00'], ['00:00'], ['00:00'], ['00:00']],
  Meal: [['08:00'], ['12:00'], ['17:00']],
}

const formatTime = (date) => {
  return dayjs(date).format('HH:mm')
}

export {
  onceTime,
  period,
  intervalTime,
  timeType,
  repeatTimes,
  formatTime,
  x,
  hr,
  mn,
}
